import React, { useEffect } from 'react';

const NotFound = () => {
  useEffect(() => {
    document.title = 'Page Not Found | XFas Logistics';
  }, []);

  return (
    <main className="min-h-[60vh] flex items-center justify-center px-4 py-24 bg-white">
      <div className="text-center max-w-md">
        <p className="text-7xl font-bold text-[#F17221]">404</p>
        <h1 className="mt-4 text-2xl font-semibold text-[#18233F]">Page not found</h1>
        <p className="mt-2 text-gray-600">
          The page you're looking for doesn't exist or has moved.
        </p>
        <div className="mt-6 flex gap-3 justify-center flex-wrap">
          <a href="/" className="bg-[#F17221] text-white px-5 py-2.5 rounded-lg font-medium hover:opacity-90">Go home</a>
          <a href="/track/" className="border border-gray-300 text-[#18233F] px-5 py-2.5 rounded-lg font-medium hover:bg-gray-50">Track a shipment</a>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
